import type { ComponentType } from 'react';
import { IoBasketballOutline, IoBaseballOutline } from 'react-icons/io5';
import type { Sport } from '@sharpr/types';

export const SPORT_ICONS: Record<Sport, ComponentType<{ className?: string }>> = {
  nba: IoBasketballOutline,
  mlb: IoBaseballOutline,
};

export const SPORT_LABELS: Record<Sport, string> = {
  nba: 'NBA',
  mlb: 'MLB',
};
